import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'components/form-components/Drawer';
import TaskDetailForm from './TaskDetailForm';

const TaskDetailDrawer = ({ taskDetail, handleClose, allUsers, allGroups }) => {
  return (
    <Drawer
      title={'text_task_detail'}
      handleClose={handleClose}
      classes='theme-font-inter-light'
      style={{ width: '35rem' }}
      headerClasses='p-3'
      backdrop={false}
      bodyComponent={<TaskDetailForm data={taskDetail} allUsers={allUsers} allGroups={allGroups} />}
    />
  );
};

TaskDetailDrawer.propTypes = {
  taskDetail: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  allUsers: PropTypes.array.isRequired,
  allGroups: PropTypes.array.isRequired,
};

export default TaskDetailDrawer;
